import { Button } from '@thg-commerce/gravity-elements'
import { mq, spacing, styled } from '@thg-commerce/gravity-theme'

export const StoreSearchResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing(4)};
  padding: ${spacing(0)} ${spacing(2)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    padding: ${spacing(1.3)} ${spacing(1.3)} ${spacing(2)} 0;
    height: 756px;
    overflow: hidden scroll;
  }
  ${(props) =>
    `&::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${props.theme.colors.palette.greys.lighter};
  }

  &::-webkit-scrollbar-thumb {
    background: ${props.theme.colors.palette.greys.grey};
  }`}
`

export const ShowMoreStoresButton = styled(Button)`
  margin: auto;
`
